<template>
    <v-btn icon @click="didTapped()">
        <v-icon>
            {{ icon }}
        </v-icon>
    </v-btn>    
</template>

<script>

export default {
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        icon() {
            return this.value ? "mdi-chevron-up" : "mdi-chevron-down"
        }
    },
    methods: {
        didTapped() {
            this.$emit("didTapped")
        },
    }
}

</script>